export default __webpack_public_path__ + "static/ski-lift-chairs-3222bd9e8befa94283d824def2c056ae.jpeg";